import React from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { getUserInformation } from '../../services/TokenHandler';
import { getCompanyProducts } from '../../utils/permissions/validatePermission';

import {
  validatePermission,
  userPermissions,
  validateCompanyOwnsProduct
} from '../../utils/permissions/validatePermission';
import { useState, useEffect } from 'react';

const SideBarNavigationItems = ({ items, isDocumentationPage }) => {
  const location = useLocation();
  const userInfo = getUserInformation();
  const {
    role: { name: nameRol }
  } = JSON.parse(userInfo);
  const navLink = (name, icon) => {
    return (
      <>
        {icon && icon}
        {name && (name === 'Reports DID' ? 'Reports' : name)}
      </>
    );
  };

  const navItem = (item, index) => {
    const { component, name, icon, ...rest } = item;
    const Component = component;

    const isHashActive = () => {
      return window.location.hash === rest.to;
    };
    return isDocumentationPage ? (
      <Component
        {...(rest.to &&
          !rest.items && {
            component: Link,
            to: rest.to
          })}
        key={name}
        {...rest}
        className={isHashActive() ? 'active' : ''}
      >
        {navLink(name, icon)}
      </Component>
    ) : (
      <Component
        {...(rest.to &&
          !rest.items && {
            component: NavLink,
            end: true
          })}
        key={name}
        {...rest}
      >
        {navLink(name, icon)}
      </Component>
    );
  };

  const navGroup = (item, index) => {
    const { component, name, icon, to, ...rest } = item;
    const Component = component;
    return (
      <Component
        idx={String(index)}
        key={name}
        toggler={navLink(name, icon)}
        visible={location.pathname.startsWith(to)}
        {...rest}
      >
        {item.items
          ?.filter((subItem) => {
            if (!isDocumentationPage) {
              return subItem.permission === 1;
            }
            return true;
          })
          .map((subItem, subIndex) =>
            subItem.items ? navGroup(subItem, subIndex) : navItem(subItem, subIndex)
          )}
      </Component>
    );
  };
  const permission = (permissionType) => {
    // console.log(userPermissions('/flane', 'get'), userInfo);
    if (isDocumentationPage) return 1;
    const defaultPermission = +true;
    const permissionName = {
      Dashboard: defaultPermission,
      Hub: defaultPermission,
      Navigator: +validatePermission(userPermissions('/access-number', 'get'), userInfo),
      'Pricing Rules':
        +validatePermission(userPermissions('/flane', 'get'), userInfo) ||
        +validatePermission(userPermissions('/cpass', 'get'), userInfo) ||
        +validatePermission(userPermissions('/vipp', 'get'), userInfo) ||
        +validatePermission(userPermissions('/vipo', 'get'), userInfo) ||
        +validatePermission(userPermissions('/vnta', 'get'), userInfo),
      FastLane:
        +validatePermission(userPermissions('/flane', 'get'), userInfo) &&
        +validateCompanyOwnsProduct('FastLane'),
      CallPass:
        +validatePermission(userPermissions('/cpass', 'get'), userInfo) &&
        +validateCompanyOwnsProduct('CallPass'),
      'VIP Phone Support':
        (+validatePermission(userPermissions('/vipp', 'get'), userInfo) ||
          +validatePermission(userPermissions('/vipo', 'get'), userInfo)) &&
        (+validateCompanyOwnsProduct('Vip Phone Support') ||
          +validateCompanyOwnsProduct('VIP Phone Support Outbound ')),
      Ventana:
        +validatePermission(userPermissions('/vnta', 'get'), userInfo) &&
        +validateCompanyOwnsProduct('Ventana'),
      WebRTC: +validatePermission(userPermissions('/webrtc', 'get'), userInfo),
      'Custom Links': defaultPermission,
      CDR: defaultPermission,
      Rules: defaultPermission,
      Channels:
        +validatePermission(userPermissions('/channels', 'get'), userInfo) ||
        +validatePermission(userPermissions('/whatsapp', 'get'), userInfo) ||
        +validatePermission(userPermissions('/webrtc', 'get'), userInfo) ||
        +validatePermission(userPermissions('/did', 'get'), userInfo) ||
        +(nameRol === 'SUPER-ADMIN') ||
        +validatePermission(userPermissions('/api-connections', 'get'), userInfo),
      'Look-up':
        +(nameRol === 'SUPER-ADMIN') ||
        +validatePermission(userPermissions('/api-connections', 'get'), userInfo),
      Records:
        +(nameRol === 'SUPER-ADMIN') ||
        +validatePermission(userPermissions('/api-connections', 'get'), userInfo),
      'Look-up Records':
        +(nameRol === 'SUPER-ADMIN') ||
        +validatePermission(userPermissions('/api-connections', 'get'), userInfo),
      'Access Logs':
        +(nameRol === 'SUPER-ADMIN') ||
        +validatePermission(userPermissions('/api-connections', 'get'), userInfo),
      'Look-up Access Logs':
        +(nameRol === 'SUPER-ADMIN') ||
        +validatePermission(userPermissions('/api-connections', 'get'), userInfo),
      WhatsApp:
        +(nameRol === 'SUPER-ADMIN') ||
        +validatePermission(userPermissions('/whatsapp', 'get'), userInfo),
      Hub: +validatePermission(userPermissions('/whatsapp-dashboard', 'get'), userInfo),
      Reports: +validatePermission(userPermissions(' /whatsapp-reports', 'get'), userInfo),
      Hub: +validatePermission(userPermissions('/did', 'get'), userInfo),
      'Custom Links': +validatePermission(userPermissions('/did', 'get'), userInfo),
      'Reports DID': +validatePermission(userPermissions('/did/call/reports', 'get'), userInfo),
      DID: +validatePermission(userPermissions('/did', 'get'), userInfo),
      'DID Manage': +validatePermission(userPermissions('/did-manage', 'get'), userInfo),
      Inventory: +validatePermission(userPermissions('/did-manage', 'get'), userInfo),
      Reports: +validatePermission(userPermissions('/reports/general', 'get'), userInfo),
      Calls: +validatePermission(userPermissions('/reports/calls', 'get'), userInfo),
      Payments: +validatePermission(userPermissions('/reports/payments', 'get'), userInfo),
      Revenue: +validatePermission(userPermissions('/reports/revenues', 'get'), userInfo),
      System:
        +validatePermission(userPermissions('/company', 'get'), userInfo) ||
        +validatePermission(userPermissions('/user', 'get'), userInfo),
      Settings:
        +validatePermission(userPermissions('/company', 'get'), userInfo) ||
        +validatePermission(userPermissions('/user', 'get'), userInfo) ||
        +validatePermission(userPermissions('/roles', 'get'), userInfo),
      // Accounts: +(
      //   (nameRol === 'SUPER-ADMIN') //TODO: Validate that only SUPER-ADMIN can access this
      // ),
      Accounts:
        +validatePermission(userPermissions('/user', 'get'), userInfo) ||
        +(
          (nameRol === 'SUPER-ADMIN') //TODO: Validate that only SUPER-ADMIN can access this
        ),
      Products: +(
        validatePermission(userPermissions('/company/products', 'post'), userInfo) &&
        nameRol === 'SUPER-ADMIN'
      ),
      Users: +(
        validatePermission(userPermissions('/user', 'get'), userInfo) && nameRol === 'SUPER-ADMIN'
      ),
      Roles: +validatePermission(userPermissions('/roles', 'get'), userInfo),
      //'Region Pricing': +validatePermission(userPermissions('/region-pricing', 'get'), userInfo),
      'Region Pricing': +(nameRol === 'SUPER-ADMIN'),
      //Twilio: +(nameRol === 'SUPER-ADMIN'),
      DID: +validatePermission(userPermissions('/did', 'get'), userInfo),
      // 'Manage DID': +(nameRol === 'SUPER-ADMIN'),
      // List: +(nameRol === 'SUPER-ADMIN'),
      // Buy: +(nameRol === 'SUPER-ADMIN'),
      'DID Manage': +validatePermission(userPermissions('/did-manage', 'get'), userInfo),
      Inventory: +validatePermission(userPermissions('/did-manage', 'get'), userInfo),
      'Buy (Conecta)': +(nameRol === 'SUPER-ADMIN'),
      'Region Pricing DID': +validatePermission(
        userPermissions('/did-region-pricing', 'get'),
        userInfo
      ),
      CDRs: +(nameRol === 'SUPER-ADMIN'),
      Interconnection:
        +(
          nameRol === 'SUPER-ADMIN' &&
          validatePermission(userPermissions('/api-connections', 'get'), userInfo)
        ) ||
        +(
          nameRol === 'SUPER-ADMIN' &&
          validatePermission(userPermissions('/node-assigns', 'get'), userInfo)
        ) ||
        +(
          nameRol === 'SUPER-ADMIN' &&
          validatePermission(userPermissions('/trunks', 'get'), userInfo)
        ),
      API: +validatePermission(userPermissions('/api-connections', 'get'), userInfo),

      Documentation: +validatePermission(userPermissions('/documentation', 'get'), userInfo),
      VoIP: +validatePermission(userPermissions('/trunks', 'get'), userInfo),

      'IVR Configuration': +validatePermission(userPermissions('/node-assigns', 'get'), userInfo),
      Cronjobs: +(nameRol === 'SUPER-ADMIN'),
      'Config Jobs': +(nameRol === 'SUPER-ADMIN'),
      'Execution Jobs': +(nameRol === 'SUPER-ADMIN'),
      'Execution Logs': +(nameRol === 'SUPER-ADMIN'),
      'Provider Call Failures': +(nameRol === 'SUPER-ADMIN'),
      Support: defaultPermission,
      'Page Not Found': defaultPermission,
      Demos:
        +(nameRol === 'SUPER-ADMIN') && +('https://console.cielo.ai' !== window.location.origin),
      'AI Agent': +(nameRol === 'SUPER-ADMIN'),
      QuickPay: +(nameRol === 'SUPER-ADMIN'),
      'VIP - Outbound': +(nameRol === 'SUPER-ADMIN'),
      Vnta: +(nameRol === 'SUPER-ADMIN'),
      WebRTC: +(nameRol === 'SUPER-ADMIN'),
      Ventana: +(nameRol === 'SUPER-ADMIN'),
      // TODO: Remove default permissions
      Invoicing: defaultPermission,
      Invoices: defaultPermission
    };

    return permissionName[permissionType];
  };

  const addNavigationChildPermission = (item) => {
    const itemChilds = item.items;
    const childWithPermissions = itemChilds.map((child) => {
      if (child.items) {
        return addNavigationChildPermission(child);
      }
      return {
        ...child,
        permission: permission(child.name)
      };
    });

    return { ...item, items: childWithPermissions, permission: permission(item.name) };
  };

  const addNavigationItemPermission = () => {
    if (!items || items.length === 0) {
      return [];
    }

    return items.map((item) => {
      return item.items
        ? addNavigationChildPermission(item)
        : { ...item, permission: permission(item.name) };
    });
  };

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    getCompanyProducts().then((prods) => {
      console.log(prods);
      setLoading(false);
    });
  }, []);
  const renderNavigationItems = () => {
    if (items) {
      return addNavigationItemPermission()
        .filter((item) => item.permission === 1)
        .map((item, index) => {
          return item.items ? navGroup(item, index) : navItem(item, index);
        });
    }

    return <></>;
  };

  return <>{items && !loading ? renderNavigationItems() : <></>}</>;
};

SideBarNavigationItems.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  isDocumentationPage: PropTypes.bool
};

export default SideBarNavigationItems;
